import { motion } from "framer-motion";
import { Users, Calendar, Headphones, DollarSign } from "lucide-react";

interface StatsSection {
  className?: string;
}
export default function StatsSection() {
  const stats = [
    {
      icon: Users,
      number: "10,000",
      label: "مقعد متاح",
      color: "#CFAE58",
    },
    {
      icon: Calendar,
      number: "30",
      label: "يوم تدريب عملي",
      color: "#CFAE58",
    },
    {
      icon: Headphones,
      number: "24/7",
      label: "دعم مباشر",
      color: "#CFAE58",
    },
    {
      icon: DollarSign,
      number: "0$",
      label: "لأول وآخر مرة مجاناً",
      color: "#CFAE58",
    },
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-[#0A1E3F] via-[#0A1E3F]/90 to-[#000000] overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#CFAE58] rounded-full blur-[150px] opacity-10"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="bg-gradient-to-br from-[#CFAE58]/10 to-transparent backdrop-blur-sm border border-[#CFAE58]/30 rounded-2xl p-8 text-center hover:border-[#CFAE58]/60 transition-all duration-300 hover:shadow-2xl hover:shadow-[#CFAE58]/20 transform hover:scale-105">
                {/* Icon */}
                <div className="mb-4 flex justify-center">
                  <div className="bg-gradient-to-br from-[#CFAE58]/20 to-[#CFAE58]/10 p-4 rounded-full">
                    <stat.icon className="w-8 h-8 text-[#CFAE58]" />
                  </div>
                </div>

                {/* Number */}
                <div className="text-5xl font-bold text-[#CFAE58] mb-2 group-hover:scale-110 transition-transform">
                  {stat.number}
                </div>

                {/* Label */}
                <div className="text-lg text-gray-300">{stat.label}</div>

                {/* Decorative Corner */}
                <div className="absolute top-2 right-2 w-8 h-8 border-t-2 border-r-2 border-[#CFAE58]/30 rounded-tr-lg"></div>
                <div className="absolute bottom-2 left-2 w-8 h-8 border-b-2 border-l-2 border-[#CFAE58]/30 rounded-bl-lg"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
